import React, { Component } from 'react'
import './Home.scss'

export class Home extends Component {
    render() {
        return (
            <div>
                <main>
                    <div className="container">
                        <a href="https://lcyljy.github.io/react/portfolio3"><div className="mainContainer"></div></a>
                    </div>
                </main>
            </div>
        )
    }
}

export default Home
